module.exports = __webpack_public_path__ + "f25cfcc86d1d969ebef0cf2b41c7d7a5.svg";